import React, { useState, useRef } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Button,
} from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import permissions from "@/api/permissions";

import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import ManageRoleModal from "../Components/ManageRoleModal";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

const buttonStyle = {
  marginRight: "10px",
};

function Roles(props) {
  const table = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCloneModalOpen, setIsCloneModalOpen] = useState(false);

  const [currentRole, setCurrentRole] = useState(null);

  const refreshTable = () => {
    table.current && table.current.loadAndStoreData();
  };

  const toggleEditModal = () => {
    isEditModalOpen && refreshTable();
    setIsEditModalOpen(!isEditModalOpen);
  };

  const toggleCloneModal = () => {
    isCloneModalOpen && refreshTable();
    setIsCloneModalOpen(!isCloneModalOpen);
  };

  const toggleCreateModal = () => {
    isModalOpen && refreshTable();
    setIsModalOpen(!isModalOpen);
  };

  const showEditRole = row => {
    setCurrentRole(row);
    toggleEditModal();
  };

  const showCloneRole = row => {
    setCurrentRole(row);
    toggleCloneModal();
  };

  const loadPagination = async (page = 0, size = 10, search, sort) => {
    let result = await permissions.getRoles(page, size, search, sort);
    return result;
  };

  const removeRole = (id, name) => {
    swal({
      title: "Are you sure?",
      text: `Are you sure you want to delete ${name} role?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      reverseButtons: false,
      preConfirm: async () => {
        await permissions.removeRole(id);
        swal(`Success`, `Role ${name} removed successfully.`, "success");
        refreshTable();
      },
    }).catch(handleError);
  };

  const actionsFormatter = (cell, row, type) => {
    const { id, name } = row;

    return (
      <>
        <Button
          style={buttonStyle}
          type="button"
          onClick={() => showEditRole(row)}>
          Edit permissions
        </Button>
        <Button
          style={buttonStyle}
          type="button"
          onClick={() => showCloneRole(row)}>
          Clone
        </Button>
        <Button
          color="success"
          type="button"
          onClick={() => removeRole(id, name)}>
          Delete
        </Button>
      </>
    );
  };

  return (
    <>
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Roles</CardHeader>
              <CardBody>
                <Form
                  inline
                  style={{
                    marginBottom: ".5rem",
                    justifyContent: "flex-end",
                  }}>
                  <FormGroup>
                    <Button
                      color="success"
                      type="button"
                      onClick={toggleCreateModal}>
                      Add role
                    </Button>
                  </FormGroup>
                </Form>
                <TableContainerWithLocation
                  loadData={loadPagination}
                  wrappedComponentRef={innerComponent => {
                    if (innerComponent) {
                      table.current = innerComponent;
                    }
                  }}>
                  <BootstrapTable
                    headerStyle={headerStyle}
                    version="4"
                    search
                    pagination
                    striped
                    hover
                    condensed
                    remote>
                    <TableHeaderColumn dataSort width="120" dataField="name">
                      Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      isKey
                      width="120"
                      dataField="id"
                      className=""
                      dataFormat={(cell, row) => actionsFormatter(cell, row)}>
                      Actions
                    </TableHeaderColumn>
                  </BootstrapTable>
                </TableContainerWithLocation>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {isModalOpen && (
        <ManageRoleModal
          isOpen={isModalOpen}
          onModalClose={toggleCreateModal}
        />
      )}

      {isEditModalOpen && (
        <ManageRoleModal
          isOpen={isEditModalOpen}
          onModalClose={toggleEditModal}
          role={currentRole}
          isEdit
        />
      )}

      {isCloneModalOpen && (
        <ManageRoleModal
          isOpen={isCloneModalOpen}
          onModalClose={toggleCloneModal}
          role={currentRole}
          isClone
        />
      )}
    </>
  );
}

export default Roles;
